module.exports = __webpack_public_path__ + "img/feed.65bed08e.jpg";